import React from "react";
import PropTypes from "prop-types";
import { Box, Flex, Image, Text, useMantineTheme } from "@mantine/core";
import { useStylesLanding } from "../../utils/mantine/useStylesLanding";
import CustomAnchor from "../mantineCustomComponents/CustomAnchor";
import { useStylesButton } from "../../utils/mantine/useStylesButton";

const SupplementaryInformation = ({ staticBasePath }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  const { classes: landingClasses } = useStylesLanding();
  const { classes: buttonClasses } = useStylesButton();
  return (
    <Box component="section" className={landingClasses.landingThree}>
      <Box className={landingClasses.landingContainer}>
        <Box
          className={`${landingClasses.landingThreeTitle} ${landingClasses.supplementaryInformationTitle}`}
        >
          Supplementary Information
        </Box>

        <Flex
          className={landingClasses.landingThreeBlocks}
          justify={theme.flex.justify.between}
        >
          <Box
            className={`${landingClasses.landingThreeBlocksItem} ${landingClasses.supplementaryInformationBlocksItem}`}
          >
            <Flex
              direction="column"
              className={landingClasses.landingThreeBlocksItemContent}
            >
              <Box>
                <Image
                  src={`${staticBasePath}public/images/svg/landing_blog_insights.svg`}
                  alt="Blog Insights"
                />
              </Box>
              <Text component="span">Blog Insights</Text>
              <Text>
                Explore our blog for insights, expert tips, and real-world
                examples on ensuring data integrity and transparency.
              </Text>
              <Flex
                align={theme.flex.align.center}
                className={`${landingClasses.pricingBlockButtons} ${landingClasses.supplementaryInformationBlockButtons}`}
              >
                <CustomAnchor
                  text="Visit Blog"
                  target="_blank"
                  href="https://www.vbase.com/blog/"
                  IconChevronRightLandingEnable="true"
                  componentClasses={`${buttonClasses.buttonWhite} ${landingClasses.pricingBlockButtonsButton} ${landingClasses.supplementaryInformationButton}`}
                />
              </Flex>
            </Flex>
          </Box>
          <Box
            className={`${landingClasses.landingThreeBlocksItem} ${landingClasses.supplementaryInformationBlocksItem}`}
          >
            <Flex
              direction="column"
              className={landingClasses.landingThreeBlocksItemContent}
            >
              <Box>
                <Image
                  src={`${staticBasePath}public/images/svg/landing_detailed_guide.svg`}
                  alt="Detailed Guide"
                />
              </Box>
              <Text component="span">Detailed Guide</Text>
              <Text>
                Master the vBase Data Stamper with our step-by-step guide.
                Assure your data’s provenance with ease and confidence.
              </Text>

              <Flex
                align={theme.flex.align.center}
                className={`${landingClasses.pricingBlockButtons} ${landingClasses.supplementaryInformationBlockButtons}`}
              >
                <CustomAnchor
                  text="How-to Guide"
                  target="_blank"
                  href="https://docs.vbase.com/getting-started/web-tools/how-to-use-vbase-stamper"
                  IconChevronRightLandingEnable="true"
                  componentClasses={`${buttonClasses.buttonWhite} ${landingClasses.pricingBlockButtonsButton} ${landingClasses.supplementaryInformationButton}`}
                />
              </Flex>
            </Flex>
          </Box>
          <Box
            className={`${landingClasses.landingThreeBlocksItem} ${landingClasses.supplementaryInformationBlocksItem}`}
          >
            <Flex
              direction="column"
              className={landingClasses.landingThreeBlocksItemContent}
            >
              <Box>
                <Image
                  src={`${staticBasePath}public/images/svg/landing_developer_resources.svg`}
                  alt="Developer Resources"
                />
              </Box>
              <Text component="span">Developer Resources</Text>
              <Text>
                Learn how vBase works under the hood. Access our comprehensive
                documentation for a full description, how-tos, samples and more.
              </Text>

              <Flex
                align={theme.flex.align.center}
                className={`${landingClasses.pricingBlockButtons} ${landingClasses.supplementaryInformationBlockButtons}`}
              >
                <CustomAnchor
                  text="Read the Docs"
                  target="_blank"
                  href="https://docs.vbase.com/"
                  IconChevronRightLandingEnable="true"
                  componentClasses={`${buttonClasses.buttonWhite} ${landingClasses.pricingBlockButtonsButton} ${landingClasses.supplementaryInformationButton}`}
                />
              </Flex>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
SupplementaryInformation.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
};
export default SupplementaryInformation;
